import { render, staticRenderFns } from "./Locker.vue?vue&type=template&id=480118fa&"
import script from "./Locker.vue?vue&type=script&lang=js&"
export * from "./Locker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports